import { createApp } from 'vue';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import './assets/css/publicStyle.css'
import './assets/css/custom-styles.css'; // 引入自定义的CSS文件
import * as ElementPlusIconsVue from '@element-plus/icons-vue';
import App from './App.vue';
import router from './router';
import axios from 'axios';
import store from './store';
import i18n from '@/i18n';

// 创建应用实例
const app = createApp(App);

// 优化图标加载 - 只注册常用的图标
const commonIcons = ['Search', 'Edit', 'Delete', 'Plus', 'Minus', 'Close', 'Check', 'Warning'];
for (const name of commonIcons) {
    if (ElementPlusIconsVue[name]) {
        app.component(name, ElementPlusIconsVue[name]);
    }
}

// 配置 axios 默认值
axios.defaults.timeout = 10000; // 设置超时时间为10秒
axios.defaults.headers.common['Cache-Control'] = 'no-cache';
axios.defaults.headers.common['Pragma'] = 'no-cache';

// 使用插件
app.use(ElementPlus, { size: 'default' });
app.provide('$axios', axios);
app.use(router);
app.use(store);
app.use(i18n);

// 优化 ResizeObserver
const debounce = (fn, delay) => {
    let timer = null;
    return function () {
        let context = this;
        let args = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            fn.apply(context, args);
        }, delay);
    }
}

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
    constructor(callback) {
        callback = debounce(callback, 16);
        super(callback);
    }
}

// 挂载应用
app.mount('#app');
